import { Box, Icon, Typography, useTheme } from "@outschool/backpack";
import { faPlus } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { getIconButtonBaseStyles, getInteractiveStyles } from "../constants";

interface InlineAddLearnerButtonProps {
  onClick: () => void;
  showLabel: boolean;
}

export default function InlineAddLearnerButton({
  onClick,
  showLabel,
}: InlineAddLearnerButtonProps) {
  const theme = useTheme();
  const { t } = useTranslation(
    "client\\components\\parentDashboardV2\\components\\LearnerBanner",
  );

  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        ...getIconButtonBaseStyles(theme),
        ...(showLabel && getInteractiveStyles(theme, false)),
        border: "none",
        gap: showLabel ? 16 : 0,
        px: showLabel ? 18 : 0,
        ...(!showLabel && {
          boxShadow: "none",
          "&:hover, &:focus-visible": {
            "& > div": {
              backgroundColor: "primary.600",
            },
          },
        }),
        [theme.breakpoints.down("md")]: {
          height: 48,
          ...(showLabel && { px: 18 }),
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.700",
          borderRadius: "100%",
          width: 24,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "background-color 0.1s ease-in-out",
        }}
      >
        <Icon icon={faPlus} sx={{ color: "white", fontSize: "1.4rem" }} />
      </Box>
      {showLabel && (
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            [theme.breakpoints.down("md")]: { fontSize: "1.4rem" },
          }}
        >
          {t("Add a learner")}
        </Typography>
      )}
    </Box>
  );
}
